module.exports = __webpack_public_path__ + "img/note.6260c362.svg";